/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{display:block;width:100%;height:100%}.logo[_ngcontent-%COMP%]{width:3.2rem;height:3.2rem;padding:.4rem;font-size:2.4rem;line-height:2.4rem;text-align:center;vertical-align:middle;display:inline-block}.logo--text[_ngcontent-%COMP%]{width:5.8rem;padding-left:0}"];
export { styles as styles };
